import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { insuranceAPI } from "../services/InsuranceService";
import error from "./slices/ErrorSlice";
import user from "./slices/UserSlice";
import filter from "./slices/FilterSlice";
import firstVisit from "./slices/FirstVisitSlice";

import complaintEdit from "./slices/ComplaintEditSlice";

export const store = configureStore({
  reducer: {
    [insuranceAPI.reducerPath]: insuranceAPI.reducer,
    error,
    user,
    complaintEdit,
    filter,
    firstVisit
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(insuranceAPI.middleware),
});

setupListeners(store.dispatch);
